export default __webpack_public_path__ + "static/meshmark-39a892fa82cf80c6b70097fc5ac4b268.png";